<template>
  <div>
    <div class="page">
      <div class="page1">
        <div class="bd7 flex-row">
          <img class="icon2" referrerpolicy="no-referrer" src="./assets/img/fanhui.png" />
          <span class="word22" @click="fanhui()">返回</span>
          <div class="block3 flex-col"></div>
          <span class="word4" style="width: auto;">{{talentData.name}}</span>
        </div>
        <div class="mod3 flex-col" v-if="talentData">
          <div class="block4 flex-row">
            <span class="word3">{{ talentData.name }}</span>
            <span class="info5">{{ talentData.salary }}</span>
            <div class="main1 flex-col"><span class="txt4" @click="seven()">编辑岗位信息</span></div>
          </div>
          <div class="block5 flex-row">
            <div class="group6 flex-col" v-if="talentData.region !=''"></div>
            <span class="info6" v-if="talentData.region !=''">{{ talentData.region }}</span>
            <div class="group7 flex-col" v-if="talentData.workYear !=''"></div>
            <span class="txt5" v-if="talentData.workYear !=''">{{ talentData.workYear }}</span>
            <div class="group8 flex-col" v-if="talentData.edu !=''"></div>
            <span class="word4" v-if="talentData.edu !=''">{{ talentData.edu }}</span>
            <div class="group9 flex-col" v-if="talentData.needPersonal !=''"></div>
            <span class="info7" v-if="talentData.needPersonal !=''">{{ talentData.needPersonal }}人</span>
            <div class="word5" :style="{
              color:
                talentData.status === 'disable'
                  ? '#FFB000'
                  : talentData.status === 'enable'
                    ? '#2c86fd'
                    : '#FF5151',
            }">
              {{
                  talentData.status === "disable"
                    ? "暂未发布"
                    : talentData.status === "enable"
                      ? "招聘中"
                      : "停止招聘"
              }}
            </div>
          </div>
          <div class="block6 flex-row" style="min-height: 20px;height: auto;margin-top: 0px;" v-if="welfare.length != 1">
            <div class="box8" v-for="item in welfare" :key="item"><span class="word6">{{ item }}</span></div>
            <span class="word7">{{ talentData.releaseTime }}</span>
          </div>
          <div v-if="welfare.length == 1" style="height:30px;"></div>
        </div>

        <div class="mod4 flex-col">
          <div class="outer4 flex-col">
            <div class="section1 flex-row justify-between">
              <div class="outer6 flex-col">
                <img src="./assets/img/job.png" />
              </div>
              <span class="info9">职位描述</span>
            </div>
            <span class="txt6">岗位职责：</span>
            <span class="paragraph1" style="white-space: pre-wrap;" v-html="talentData.introduce">
            </span>
            <div class="section2 flex-row justify-between">
              <img src="./assets/img/dingwei.png" alt="">
              <span class="word9">工作地点</span>
            </div>
            <span class="txt7">{{ talentData.address || '没有地址' }}</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      positionId: this.$route.query.positionId,
      page: 1,
      pageSize: 10,
      talentData: {},
      welfare: [],
    }
  },
  methods: {
    fanhui() {
      this.$router.push({ path: 'Talent' })
    },
    seven(){
      this.$router.push({ path: '/addtalent',query: { id: this.talentData.id }})
    }
  },
  mounted() {
    this.$apiFun.positionDetails({
      companyId: localStorage.getItem("id"),
      positionId: this.positionId,
      sex: 0,
      sourceType: "user,AI,active",
      manageStatus: 0,
      page: this.page,
      pageSize: this.pageSize,
    }).then((data) => {
      if (data.code === 200) {
        this.talentData = data.data;
        this.welfare = this.talentData.welfare.split(',');

      }
    })
  }
}
</script>




<style scoped lang="less" src="./assets/datas.less" />
<style lang="less" scoped>
.mod3 {
  height: auto !important;
}

.block6 {
  flex-flow: wrap;
  margin-bottom: 8px !important;
}
.mod4{
  height: auto;
  padding-bottom: 5vh;
  margin-bottom: 10vh;
}
.mod4 .outer4{
  height: auto;
}
.mod4 .outer4 .paragraph1{
  height: auto;
}
.page {
  width: calc(100% - 20px);
  overflow-y: scroll;

  .page1 {
    width: 100%;
    height: auto;
    border-radius: 4px;

    .page1wrap {
      width: 100%;
      height: auto;

      .layer13 {
        float: left;
        margin-right: 20px;
      }
    }
  }
}

.bd7 {
  width: 139px;
  height: 18px;
  margin: 15px 0 0 50px;

  .icon2 {
    width: 12px;
    height: 12px;
    margin-top: 3px;
  }

  .word22 {
    width: 29px;
    height: 18px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(108, 110, 113, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 18px;
    text-align: center;
    margin-left: 2px;
    cursor: pointer;
  }

  .block3 {
    width: 4px;
    height: 16px;
    background-color: rgba(62, 124, 255, 1);
    margin: 1px 0 0 10px;
  }

  .word4 {
    width: 72px;
    height: 18px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 18px;
    text-align: center;
    margin-left: 10px;
  }
}
</style>